module.exports = __webpack_public_path__ + "img/pagepunti.2aa151c1.png";